<template>
  <div class="p-0">
    <b-container>
      <b-row class="">
        <row-item>
          <template v-slot:title>{{ $t('棋盤') }}</template>
          <template v-slot:content>
            <dropdown
              v-model="boardSize"
              :title="$t('棋盤')"
              :options="boardSizeOptions"
            ></dropdown>
          </template>
        </row-item>
      </b-row>
      <b-row class="mt-3">
        <row-item>
          <template v-slot:title>{{ $t('時限') }}</template>
          <template v-slot:content>
            <dropdown
              v-model="time"
              :title="$t('時限')"
              :options="timeOptions"
            ></dropdown>
          </template>
        </row-item>
      </b-row>
      <b-row class="mt-3">
        <row-item>
          <template v-slot:title>{{ $t('讀秒') }}</template>
          <template v-slot:content>
            <dropdown
              v-model="byoYomiTime"
              :title="$t('讀秒秒數')"
              :options="byoYomiTimeOptions"
              class="flex-fill mr-2"
            ></dropdown>
            <dropdown
              v-model="byoYomiAmount"
              :title="$t('讀秒次數')"
              :options="byoYomiAmountOptions"
              :disabled="byoYomiTime === 0"
              class="flex-fill"
            ></dropdown>
          </template>
        </row-item>
      </b-row>
      <b-row class="mt-3">
        <row-item>
          <template v-slot:title>{{ $t('黑白') }}</template>
          <template v-slot:content>
            <b-form-radio-group v-model="userColor" class="w-100 d-flex">
              <b-form-radio
                v-for="(userColorOption, index) in userColorOptions"
                :key="userColorOption.value"
                class="w-50 mr-0"
                :class="{'mr-2': index < userColorOptions.length - 1}"
                :value="userColorOption.value"
                >{{ userColorOption.text }}</b-form-radio
              >
            </b-form-radio-group>
          </template>
        </row-item>
      </b-row>
      <b-row class="mt-3">
        <row-item>
          <template v-slot:title>{{ $t('手合') }}</template>
          <template v-slot:content>
            <b-form-radio-group v-model="hasHandicap" class="w-100 d-flex">
              <b-form-radio
                v-for="(handicapOption, index) in handicapOptions"
                :key="handicapOption.value"
                class="w-50 mr-0"
                :class="{'mr-2': index < handicapOptions.length - 1}"
                :value="handicapOption.value"
                :disabled="handicapOption.disabled"
                >{{ handicapOption.text }}</b-form-radio
              >
            </b-form-radio-group>
          </template>
        </row-item>
      </b-row>
      <b-row v-if="hasHandicap" class="mt-3">
        <row-item>
          <template v-slot:title>{{ $t('數量') }}</template>
          <template v-slot:content>
            <dropdown
              v-model="handicapCount"
              :title="$t('數量')"
              :options="handicapCountOptions"
            ></dropdown>
          </template>
        </row-item>
      </b-row>
      <b-row v-if="hasButton" class="mt-3">
        <b-button
          class="w-100 font-weight-bold"
          variant="primary"
          size="fixed-lg"
          @click="createRoom"
          >{{ $t('建立') }}</b-button
        >
      </b-row>
    </b-container>
  </div>
</template>

<script>
import RowItem from '@/components/Base/RowItem';
import Dropdown from '@/components/Base/Dropdown';
import socket from '@/lib/socket/authSocket.js';
import pvpService from '@/services/pvp.js';

export default {
  props: {
    hasButton: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RowItem,
    Dropdown,
  },
  data() {
    return {
      boardSizeOptions: [
        {value: 9, label: this.$t('{v1}路', {v1: 9})},
        {value: 13, label: this.$t('{v1}路', {v1: 13})},
        {value: 19, label: this.$t('{v1}路', {v1: 19})},
      ],
      timeOptions: [
        {value: 0, label: this.$t('{v1}分鐘', {v1: 0})},
        {value: 5, label: this.$t('{v1}分鐘', {v1: 5})},
        {value: 10, label: this.$t('{v1}分鐘', {v1: 10})},
        {value: 15, label: this.$t('{v1}分鐘', {v1: 15})},
        {value: 20, label: this.$t('{v1}分鐘', {v1: 20})},
        {value: 25, label: this.$t('{v1}分鐘', {v1: 25})},
        {value: 30, label: this.$t('{v1}分鐘', {v1: 30})},
        {value: 35, label: this.$t('{v1}分鐘', {v1: 35})},
        {value: 40, label: this.$t('{v1}分鐘', {v1: 40})},
        {value: 45, label: this.$t('{v1}分鐘', {v1: 45})},
        {value: 50, label: this.$t('{v1}分鐘', {v1: 50})},
        {value: 55, label: this.$t('{v1}分鐘', {v1: 55})},
        {value: 60, label: this.$t('{v1}分鐘', {v1: 60})},
      ],
      byoYomiTimeOptions: [
        {value: 0, label: this.$t('{v1}秒', {v1: 0})},
        {value: 10, label: this.$t('{v1}秒', {v1: 10})},
        {value: 15, label: this.$t('{v1}秒', {v1: 15})},
        {value: 20, label: this.$t('{v1}秒', {v1: 20})},
        {value: 30, label: this.$t('{v1}秒', {v1: 30})},
        {value: 40, label: this.$t('{v1}秒', {v1: 40})},
        {value: 60, label: this.$t('{v1}秒', {v1: 60})},
      ],
      userColorOptions: [
        {value: 'random', text: this.$t('猜子')},
        {value: 'black', text: this.$t('黑')},
        {value: 'white', text: this.$t('白')},
      ],
      handicapCountOptions: [
        {value: 1, label: this.$t('讓先')},
        {value: 2, label: this.$t('讓{v1}子', {v1: 2})},
        {value: 3, label: this.$t('讓{v1}子', {v1: 3})},
        {value: 4, label: this.$t('讓{v1}子', {v1: 4})},
        {value: 5, label: this.$t('讓{v1}子', {v1: 5})},
        {value: 6, label: this.$t('讓{v1}子', {v1: 6})},
        {value: 7, label: this.$t('讓{v1}子', {v1: 7})},
        {value: 8, label: this.$t('讓{v1}子', {v1: 8})},
        {value: 9, label: this.$t('讓{v1}子', {v1: 9})},
      ],
      time: 10,
      byoYomiTime: 10,
      byoYomiAmount: 3,
      boardSize: 9,
      hasHandicap: false,
      handicapCount: 1,
      userColor: 'random',
      oldDropdown: null,
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters['env/isLoading'];
    },
    byoYomiAmountOptions() {
      // 防止prettier自動換行產生空白
      // prettier-ignore
      return this.byoYomiTime === 0
        ? [
          {value: 0, label: this.$t('{v1}次', {v1: 0})},
        ]
        : [
          {value: 1, label: this.$t('{v1}次', {v1: 1})},
          {value: 2, label: this.$t('{v1}次', {v1: 2})},
          {value: 3, label: this.$t('{v1}次', {v1: 3})},
          {value: 4, label: this.$t('{v1}次', {v1: 4})},
          {value: 5, label: this.$t('{v1}次', {v1: 5})},
        ];
    },
    handicapOptions() {
      return [
        {
          value: false,
          text: this.$t('不讓子'),
        },
        {
          value: true,
          text: this.$t('讓子'),
          disabled: this.userColor === 'random',
        },
      ];
    },
  },
  watch: {
    boardSize() {
      this.storeTimeSetting();
    },
    time() {
      this.storeTimeSetting();
    },
    byoYomiTime(newValue, oldValue) {
      this.storeTimeSetting();
      if (newValue > 0 && oldValue === 0) {
        this.byoYomiAmount = 1;
      } else if (newValue === 0) {
        this.byoYomiAmount = 0;
      }
    },
    byoYomiAmount() {
      this.storeTimeSetting();
    },
    hasHandicap() {
      this.storeTimeSetting();
    },
    userColor(newValue) {
      this.storeTimeSetting();
      if (newValue === 'random') {
        this.hasHandicap = false;
      }
    },
    handicapCount() {
      this.storeTimeSetting();
    },
  },
  created() {
    const prevTimeSettingString = localStorage.getItem('pvp.timeSetting');
    if (prevTimeSettingString) {
      const prevTimeSetting = JSON.parse(prevTimeSettingString);
      prevTimeSetting.time = prevTimeSetting.time / 60;
      Object.assign(this.$data, prevTimeSetting);
    }
  },
  beforeDestroy() {
    socket.clearEvents([
      socket.SendEventEnum.PVP_CREATE_LOBBY,
      socket.ResponseEventEnum.PVP_CREATE_LOBBY_SUCCESSFULLY,
    ]);
  },
  destroyed() {
    this.$store.commit('env/setIsLoading', false);
  },
  methods: {
    async createRoom() {
      if (this.isLoading) {
        return;
      }
      const data = {
        boardSize: this.boardSize,
        time: this.time * 60,
        byoYomiTime: this.byoYomiTime,
        byoYomiAmount: this.byoYomiAmount,
        userColor: this.userColor === 'random' ? null : this.userColor,
        hasHandicap: this.hasHandicap,
        handicap: this.hasHandicap ? this.handicapCount : 0,
      };
      this.storeTimeSetting();
      this.$store.commit('env/setIsLoading', true);
      const lobby = await pvpService.createLobby(data);
      this.$store.commit('env/setIsLoading', false);
      const {komi, lobbyId} = lobby;
      this.$store.commit('pvp/setLobbyDetails', {komi});
      this.$router.push({name: 'pvp-lobby', params: {id: lobbyId}});
    },
    storeTimeSetting() {
      const data = {
        boardSize: this.boardSize,
        time: this.time * 60,
        byoYomiTime: this.byoYomiTime,
        byoYomiAmount: this.byoYomiAmount,
        isPublic: false,
        hasHandicap: this.hasHandicap,
        userColor: this.userColor,
        handicapCount: this.handicapCount,
      };
      this.$store.commit('pvp/setLobby', data);
      localStorage.setItem('pvp.timeSetting', JSON.stringify(data));
    },
  },
};
</script>

<style lang="scss" scoped>
:deep() .custom-control-input[disabled] ~ .custom-control-label::before,
.custom-control-input:disabled ~ .custom-control-label::before {
  background-color: white;
  border-color: #dcdfe5;
}
:deep() .custom-control-input[disabled] ~ .custom-control-label,
.custom-control-input:disabled ~ .custom-control-label {
  color: $font-grayscale-3;
}
</style>
